export default __webpack_public_path__ + "static/ejr-afcfe9999d142bf4b7a438a0a7277a4c.mp4";